<template>
    <div class="login-modal">
        <el-dialog v-model="modelValueState" @closed="$emit('closed')" :show-close="false">
            <template #header>
                <div>
                    <img :src="$config.header_logo_url">
                </div>
                <CloseModalButton @click="modelValueState = false"/>
            </template>
            <template v-if="successMessage">
                <el-row>
                    <div class="success-wrapper">{{ successMessage }}</div>
                </el-row>
            </template>
            <template v-else>
                <el-row>
                    <el-col :span="24" class="title-col">
                        <div>{{ $trans('web_search.checkout_login_modal.modal_title') }}</div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form ref="formRef" label-position="top" label-width="100px" :model="formData" :rules="rules"
                            :show-message="true" :validate-on-rule-change="false" require-asterisk-position="right">
                            <el-form-item :label="$trans('web_search.checkout_fields.email')" required prop="email" autocomplete="off">
                                <el-input v-model="formData.email" :validate-event="false" disabled/>
                            </el-form-item>
                            <el-form-item :label="$trans('web_search.checkout_fields.password')" required prop="password" autocomplete="off">
                                <el-input type="password" v-model="formData.password" :validate-event="false"/>
                            </el-form-item>
                            <div class="error-wrapper" v-if="message">
                                {{ message }}
                            </div>
                            <el-form-item class="center" prop="remember">
                                <el-checkbox v-model="formData.remember" id="rememberMe" :validate-event="false"/>
                                <label for="rememberMe" style="margin-left: 10px;">{{ $trans('messages.remember_me') }}</label>
                            </el-form-item>
                            <el-form-item class="center">
                                <el-button :loading="isSubmitting" @click="onSubmit()">{{ $trans('messages.login') }}</el-button>
                            </el-form-item>
                            <el-form-item class="center">
                                <div>
                                    {{ $trans('messages.forgot_password') }} <span>{{ $trans('messages.click') }} </span> <a target="_blank" href="/password/reset" style="color: #ffffff"><span style="color: #ff6b65"><b> {{ $trans('messages.here') }}</b></span></a>
                                </div>
                            </el-form-item>
                        </el-form>
                    </el-col>
                </el-row>
            </template>
            <template #footer v-if="!successMessage">
                <AuthFooterModal/>
            </template>
        </el-dialog>
    </div>
</template>

<script>
import AuthFooterModal from './../Auth/AuthFooterModal';
import CloseModalButton from './CloseModalButton';
import { mapStores } from 'pinia';
import { useCandidateBoardStore } from '@/stores/CandidateBoardStore';

export default {
    props: ['modelValue', 'formDataProp'],
    emits: ['update:modelValue', 'closed'],
    components: {
        AuthFooterModal,
        CloseModalButton,
    },
    data() {
        return {
            isSubmitting: false,
            modelValueState: false,
            message: false,
            successMessage: false,
            formData: {
                board_name: '',
                email: '',
                password: '',
                remember: false,
            },
            rules: {
                email: [
                    { required: true, message: this.$trans('web_search.checkout_field_errors.required') },
                ],
                password: [
                    { required: true, message: this.$trans('web_search.checkout_field_errors.required') },
                ],
            },
        };
    },
    computed: {
        ...mapStores(useCandidateBoardStore),
    },
    methods: {
        async onSubmit() {
            if (this.isSubmitting) return;

            var self = this;

            await this.$refs.formRef.validate((valid, fields) => {
                if (valid) {
                    self.isSubmitting = true;
                    const login = this.ajaxLogin();

                    login.then(function (result) {
                        if (result.status == 'success') {
                            const createVacancy = self.ajaxCreateVacancy();

                            createVacancy.then(function (result) {
                                if (result.status == 'success') {
                                    self.redirectAfterCreateVacancy();
                                } else {
                                    self.message = result.message;
                                    self.isSubmitting = false;
                                }
                            }).catch(function() {
                                self.isSubmitting = false;
                            });
                        } else {
                            self.message = result.message;
                            self.isSubmitting = false;
                        }
                    }).catch(function() {
                        self.isSubmitting = false;
                    });
                }
            });
        },
        async ajaxLogin() {
            const response = await fetch('/login', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    vacancy_name: this.formData.board_name,
                    vacancy_managers: this.CandidateBoardStore.getProfileIds(),
                    vacancy_manager_criterias: this.CandidateBoardStore.getProfileCriterias(),
                    email: this.formData.email,
                    password: this.formData.password,
                    remember: this.formData.remember,
                    _token: document.head.querySelector('meta[name="csrf-token"]').content,
                })
            });

            return await response.json();
        },
        async ajaxCreateVacancy() {
            const response = await fetch('/api/web-search/create-vacancy', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    vacancy_name: this.formData.board_name,
                    vacancy_managers: this.CandidateBoardStore.getProfileIds(),
                    vacancy_manager_criterias: this.CandidateBoardStore.getProfileCriterias(),
                    _token: document.head.querySelector('meta[name="csrf-token"]').content,
                })
            });

            return await response.json();
        },
        redirectAfterCreateVacancy() {
            let delay = 5000;
            this.successMessage = this.$trans('web_search.checkout_response_messages.success_please_wait_to_redirecting');

            setTimeout(function () {
                window.location = '/opnhr/candidate-boards';
            }, delay);
        },
    },
    watch: {
        modelValue: function () {
            this.modelValueState = this.modelValue;
            this.isSubmitting = false;
        },
        formDataProp: function () {
            this.formData = { ...this.formData, ...this.formDataProp, };
        },
    }
}
</script>

<style scoped>
.login-modal :deep(.el-dialog) {
    --el-dialog-width: 600px;
}

.center {
    text-align: center;
}

.success-wrapper {
    color: #81BC8F;
    text-align: center;
    font-weight: bold;
    width: 100%;
}

.error-wrapper {
    color: #FF6B65;
    font-style: italic;
}

.login-modal :deep(.el-dialog .el-dialog__header) {
    padding-bottom: 0;
}

.login-modal :deep(.el-dialog .el-dialog__body) {
    padding-bottom: 20px;
}

.login-modal :deep(.el-dialog .el-dialog__footer) {
    padding: 0;
}

.login-modal :deep(.el-form--default.el-form--label-top .el-form-item .el-form-item__label) {
    margin-bottom: 0px;
}

.login-modal :deep(.center .el-form-item__content) {
    justify-content: center;
}

.login-modal :deep(.el-form-item:last-child) {
    margin-bottom: 0;
}

.login-modal .el-row {
    background-color: #ededed;
    color: rgb(60, 60, 60);
    padding-bottom: 18px;
}

.login-modal .el-row:first-child {
    padding-top: 18px;
}

.login-modal .el-col {
    padding: 0 15px;
}

.login-modal .title-col div {
    text-align: left;
    font: normal normal 500 24px/29px Barlow;
    letter-spacing: -0.24px;
    color: #3C3C3C;
    padding-top: 4px;
    padding-bottom: 4px;
    border-bottom: 1px solid rgb(60, 60, 60);
}

.login-modal .el-button {
    background-color: #41ABC4;
    color: #fff;
    border-radius: 4px;
    height: 40px;
    width: 100%;
    max-width: 60%;
    font-size: 18px;
    font-weight: 300;
}

.login-modal .el-button:hover {
    background-color: #2699b2;
}

.login-modal .el-checkbox {
    --el-checkbox-font-size:14px;
    --el-checkbox-font-weight:var(--el-font-weight-primary);
    --el-checkbox-text-color:#3C3C3C;
    --el-checkbox-input-height:14px;
    --el-checkbox-input-width:14px;
    --el-checkbox-border-radius:0;
    --el-checkbox-bg-color:white;
    --el-checkbox-input-border:1px solid #41ABC4;
    --el-checkbox-disabled-border-color:var(--el-border-color);
    --el-checkbox-disabled-input-fill:var(--el-fill-color-light);
    --el-checkbox-disabled-icon-color:var(--el-text-color-placeholder);
    --el-checkbox-disabled-checked-input-fill:var(--el-border-color-extra-light);
    --el-checkbox-disabled-checked-input-border-color:var(--el-border-color);
    --el-checkbox-disabled-checked-icon-color:var(--el-text-color-placeholder);
    --el-checkbox-checked-text-color:#3C3C3C;
    --el-checkbox-checked-input-border-color:#41ABC4;
    --el-checkbox-checked-bg-color:#41ABC4;
    --el-checkbox-checked-icon-color:var(--el-color-white);
    --el-checkbox-input-border-color-hover:#41ABC4;

    height:24px;
}

/* max-wdith = width of modal + 50px */
@media only screen and (max-width: 650px) {
    .login-modal :deep(.el-dialog) {
        --el-dialog-width: 95%;
    }
}
</style>
